class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    const countdownDate = this.dataset.countdown;
    if (!countdownDate) {
      console.warn('Countdown timer requires data-countdown attribute');
      return;
    }

    this.targetDate = new Date(countdownDate);
    this.hoursElement = this.querySelector('.countdown-hours');
    this.minutesElement = this.querySelector('.countdown-minutes');
    this.secondsElement = this.querySelector('.countdown-seconds');

    if (!this.hoursElement || !this.minutesElement || !this.secondsElement) {
      console.warn('Countdown timer requires .countdown-hours, .countdown-minutes, and .countdown-seconds elements');
      return;
    }

    this.startCountdown();
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  startCountdown() {
    this.updateCountdown();
    this.interval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.targetDate.getTime() - now;

    if (distance < 0) {
      this.handleExpiredCountdown();
      return;
    }

    const hours = Math.floor(distance / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.hoursElement.textContent = this.padNumber(hours);
    this.minutesElement.textContent = this.padNumber(minutes);
    this.secondsElement.textContent = this.padNumber(seconds);
  }

  padNumber(num) {
    return num.toString().padStart(2, '0');
  }

  handleExpiredCountdown() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    
    this.hoursElement.textContent = '00';
    this.minutesElement.textContent = '00';
    this.secondsElement.textContent = '00';
    
    // Dispatch custom event for expired countdown
    this.dispatchEvent(new CustomEvent('countdown-expired', {
      bubbles: true,
      detail: { element: this }
    }));
  }
}

customElements.define('countdown-timer', CountdownTimer);